export default function UnsavedActionForm() {
  const action = useSel(s => s.actions.entities[s.local.selectedActionId])
  const selectedPageNumber = useSel(s => s.local.selectedPageNumber)

  let title = ''
  let text = []

  switch (action.kind) {
    case 'redirect':
      title = 'Redirect'
      text = ['Please save to add a URL to redirect to']
      break
    case 'share':
      title = 'Share Page'
      text = ['Please save to add a share channels and text']
      break
    case 'lunda':
      title = 'Lunda donation form'
      text = ['Please save to add your embed URL']
      break
    case 'fundraise_up':
      title = 'Fundraise Up donation form'
      text = ['Please save to add your element embed code']
      break
    case 'email_to_target':
      title = 'Email to Target'
      text = ['Please save to configure this step']
      break
    case 'survey':
      title = `Page ${selectedPageNumber}`
      text = ['No questions added to this page yet', 'Please save to begin adding questions to your survey']
      break
    case 'donate':
      title = 'Donation'
      text = ['Please save to configure this step']
      break
    case 'custom':
      title = 'Custom Action'
      text = ['Please save to configure this step']
      break
    default:
      title = 'Unsaved Action'
      text = ['Please save to configure this step']
  }

  return (
    <div className="box narrow">
      <h2 className='no-margin-top'>{title}</h2>
      {text.map((line, index) => (
        <p key={index} className="margin-top">{line}</p>
      ))}
    </div>
  )
}
